// Separate module to ensure window.jQuery is set before any other module
// that checks window.jQuery at evaluation time (e.g. imagesloaded, flickity).
// ES module imports are hoisted and evaluated before the importing module's
// body runs, so window.jQuery = $ in the entry file would be too late.
import $ from "jquery";
window.$ = window.jQuery = $;
